const error = state => {
  return state.error
}

const loading = state => {
  return state.loading
}

export default {
  error,
  loading
}



// WEBPACK FOOTER //
// ./src/store/modules/auth/getters.js